import { useState, useEffect, useLayoutEffect, useCallback } from "react";
import { format, parse, isBefore, isAfter, isEqual, addHours, differenceInMilliseconds, addDays } from "date-fns";  // Import necessary date-fns functions
import { CheckCircleIcon, ClockIcon, ExclamationCircleIcon, ChevronLeftIcon, ChevronRightIcon, PlusCircleIcon, ArrowsRightLeftIcon, MagnifyingGlassPlusIcon, MagnifyingGlassMinusIcon, ClipboardDocumentCheckIcon, ChevronDoubleDownIcon, QuestionMarkCircleIcon, UserCircleIcon } from "@heroicons/react/20/solid";
import { useNavigate } from 'react-router-dom';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { ArrowLeftStartOnRectangleIcon, MinusCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import ManagerNav from "./managernav";
import TaskHome from "./taskhome";
import Bottlenecks from "./bottlenecks";
import SubstepViewer from "./viewsubsteps";
import { UserAddIcon } from "@heroicons/react/20/solid";
import { ChevronDoubleRightIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function DailyTaskTimeline({date}) {
  const user = useContext(AuthContext);

  const [tasks, setTasks] = useState([]);
  const [currentTask, setCurrentTask] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [timeToNextTask, setTimeToNextTask] = useState(0);  // Time to next task in milliseconds
  const [elapsedTime, setElapsedTime] = useState(0);  // Time elapsed since last update
  const [progress, setProgress] = useState(0);  // Progress bar value
  const [currentDate, setCurrentDate] = useState(new Date()); // State to manage current date
  const [instructionsTaskId, setInstructionsTaskId] = useState(null);
const [instructionText, setInstructionText] = useState("");
  const [taskTally, setTaskTally] = useState({});
  const [staffMembers, setStaffMembers] = useState({});
  const Navigate = useNavigate();
  const [changeTask, setChangeTask] = useState(null);
  const [change, setChange] = useState([]);
const [openDropdown, setOpenDropdown] = useState(null);
const [roles, setRoles] = useState([]);
const [newRole, setNewRole] = useState("");
const [zoom, setZoom] = useState(1);
const [bottleneck, setBottleneck] = useState(null);
const [selectedTaskId, setSelectedTaskId] = useState(null);
  // Fetch tasks from the backend with the selected date

  const getTaskEndTime = (task, taskStartTime) => {
    const rawEnd = String(task?.EndTime || '').substring(0, 8);
    if (rawEnd) {
      const parsedEnd = parse(rawEnd, 'HH:mm:ss', new Date());
      if (!isNaN(parsedEnd) && isAfter(parsedEnd, taskStartTime)) {
        return parsedEnd;
      }
    }
    return addHours(taskStartTime, 1);
  };

  const handleTaskSelect = (taskId) => {
    setSelectedTaskId(taskId === selectedTaskId ? null : taskId); // Toggle selection
  };

  // if date comes from the parent component, set the current date to the date from the parent component

  useEffect(() => {
    if (date) {
      setCurrentDate(date);
    }
  }, [date]);


  const fetchData = useCallback(() => {
    const fetchTasks = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch("https://api.insightos.co.uk/api/teamdailytasks", {
          method: "POST",
          headers: { 'Content-Type': 'application/json', }, credentials: 'include',
          body: JSON.stringify({ date: format(currentDate, "yyyy-MM-dd") }),
        });




       

        if (!response.ok) {
          throw new Error("Failed to fetch tasks.");
        }

        const data = await response.json();

        // Sort tasks by StartTime (chronological order)
        const sortedTasks = data.data.sort((a, b) =>
          parse(a.StartTime, "HH:mm:ss", new Date()) - parse(b.StartTime, "HH:mm:ss", new Date())
        );

        setTasks(sortedTasks);

        // create a tally of the tasks for the day

        const taskTally = sortedTasks.reduce((tally, task) => {
          if (tally[task.Task]) {
            tally[task.Task] += 1;
          } else {
            tally[task.Task] = 1;
          }
          return tally;
        }, {});

        console.log(taskTally);

        // now using.Name find out how different names are there in the taskTally object

        const staffMembers = sortedTasks.reduce((tally, task) => {
          if (tally[task.Name]) {

          } else {

            tally[task.Name] = 1;

          }

          return tally;

        }, {});

        // find out how many staff members are there in the staffMembers object

        setStaffMembers(staffMembers);

         // Get all the .Role from the sortedTasks array, remove duplicates, and then set them in state
setRoles([...new Set(sortedTasks.map((task) => task.Role))]);

          

        console.log(staffMembers);



        setTaskTally(taskTally);



        // Determine the current task based on the current time
        const now = new Date();
        const current = sortedTasks.find((task) => {
          const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
          const taskEndTime = getTaskEndTime(task, taskStartTime);
          return isEqual(taskStartTime, now) || (isBefore(taskStartTime, now) && isAfter(taskEndTime, now));
        });

        if (current) {
          setCurrentTask(current);
        }

        // Find the next task and calculate time to it
        const nextTask = sortedTasks.find((task) => {
          const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
          return isAfter(taskStartTime, now);
        });

        if (nextTask) {
          const nextTaskStartTime = parse(nextTask.StartTime, "HH:mm:ss", new Date());
          const timeDiff = differenceInMilliseconds(nextTaskStartTime, now);
          setTimeToNextTask(timeDiff);
        }
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }

    fetchTasks();

  });



  useEffect(() => {
    fetchData();
  }, [currentDate]);





 

  // Update the current time every second
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);  // Cleanup on unmount
  }, []);

  // Update progress bar every second
  useEffect(() => {
    if (timeToNextTask > 0) {
      const intervalId = setInterval(() => {
        setElapsedTime((prevTime) => prevTime + 1000);  // Increase elapsed time by 1 second

        // Calculate the progress as a percentage of the total time
        const progressPercent = (elapsedTime / timeToNextTask) * 100;

        if (progressPercent < 100) {
          setProgress(progressPercent);
        } else {
          setProgress(100);
        }
      }, 1000);

      return () => clearInterval(intervalId); // Cleanup on unmount
    }
  }, [timeToNextTask, elapsedTime]);

  // Scroll to current task after tasks have been rendered
  useLayoutEffect(() => {
    if (currentTask && tasks.length > 0) {
      const currentTaskElement = document.getElementById(currentTask.TaskID); // Ensure we're getting the correct element
      if (currentTaskElement) {
        currentTaskElement.scrollIntoView({ behavior: 'smooth', block: 'center' }); // Scroll smoothly to the current task
      }
    }
  }, [currentTask, tasks]); // Re-run if currentTask or tasks change

  // Handle date change (Previous or Next)
  const handleDateChange = (direction) => {
    const newDate = addDays(currentDate, direction === 'next' ? 1 : -1);  // Add or subtract one day
    setCurrentDate(newDate);
  };

  const groupedTasks = tasks.reduce((groups, task) => {
    const taskStartTime = format(parse(task.StartTime, "HH:mm:ss", new Date()), "HH:mm");
    if (!groups[taskStartTime]) {
      groups[taskStartTime] = [];
    }
    groups[taskStartTime].push(task);
    return groups;
  }, {});

  // Prepare data for the Pie Chart
  const pieChartData = Object.entries(taskTally).map(([task, count]) => ({
    name: task,
    value: count,
  }));

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];

  // Handle priority change

const handlePriorityChange = async (taskId, action) => {


  // Find the task by ID
  const priorityLevels = ["Low", "Medium", "High"]; // Priority levels in order

  // match the task id with the task id in the tasks array
  const task = tasks.find((task) => task.TaskID === taskId);

  // find the index of the current priority level
  const currentPriorityIndex = priorityLevels.indexOf(task.Priority);

  let newPriorityIndex = currentPriorityIndex;

  if (action === "increase" && currentPriorityIndex < priorityLevels.length - 1) {
    newPriorityIndex += 1; // Move up in priority
  } else if (action === "decrease" && currentPriorityIndex > 0) {
    newPriorityIndex -= 1; // Move down in priority
  }

  const newPriority = priorityLevels[newPriorityIndex];

  console.log("New Priority:", newPriority);

  
  const id = taskId;

  try {

  const response = await fetch("https://api.insightos.co.uk/api/prioritychange", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: 'include',
    body: JSON.stringify({ id, priority: newPriority }), // Change "newPriority" to "priority"
  });
  
  

    if (!response.ok) {
      throw new Error("Failed to update priority.");
    }

    const data = await response.json();

    if (data.success) {

   fetchData();
   
      console.log("Priority updated successfully.");
    }
  }

  catch (error) {
    console.error("Error updating priority:", error);
  }

};



useEffect(() => {

  // get the tasks from the backend
  async function fetchTasks() {
    

    try {
      const response = await fetch("https://api.insightos.co.uk/api/tasks", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",

        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tasks.");
      }

      const data = await response.json();

      // filter Tasks from the data


      const tasks = data.data;

// Map over the data to extract the task strings, then split each string into individual tasks, and merge them into one array
const all = data.data
  .map((task) => task.Tasks) // Get the nested arrays of tasks
  .flat() // Flatten the array of arrays
  .map((task) => task.split(',')) // Split each task string by commas
  .flat(); // Flatten again to get one array of individual tasks

// Set the merged array to state
setChange(all);

      






     
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  }

  fetchTasks();

}, [changeTask]); // Empty dependency array to run once



const handleNewTask = async (newTask, taskId) => {
  
  const id = taskId;

  console.log(newTask);
  console.log(id);

  const Task = newTask;

  try {

    const response = await fetch("https://api.insightos.co.uk/api/changetask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify({ id, Task }),
    });

    if (!response.ok) {
      throw new Error("Failed to update task.");
    }

    const data = await response.json();

    if (data.success) {

      console.log("Task updated successfully.");

    

fetchData();
      setOpenDropdown(null);

    }

  } catch (error) {
    console.error("Error updating task:", error);
  }

};


useEffect(() => {

  console.log(newRole);

  // if newRole is all dont filter the tasks array

  if (newRole === "all") {
    fetchData();
    return;
  }


  // get the tasks state and then filter the newRole and .Role from the tasks array and re set in state

  const filteredTasks = tasks.filter((task) => task.Role === newRole);

  console.log(filteredTasks);

  setTasks(filteredTasks);

}, [newRole]);




  // Handle Zoom In
  const handleZoomIn = () => setZoom((prev) => prev + 0.1);
  const handleZoomOut = () => setZoom((prev) => (prev - 0.1 > 0.5 ? prev - 0.1 : 0.5));



// Function to calculate and return task completion percentages
const calculateTaskCompletion = () => {

  const tasksWithoutBreak = tasks.filter((task) => !task.Task.toLowerCase().includes("Break"));

  const completedTasks = tasksWithoutBreak.filter((task) => task.Completed === 1).length;
  
  const incompleteTasks = tasksWithoutBreak.filter((task) => task.Completed === 0).length;
  const totalTasks = tasksWithoutBreak.length;

  // Handle division by zero when there are no tasks
  const totalSafe = totalTasks || 1;
  const completedPercent = (completedTasks / totalSafe) * 100;
  const incompletePercent = (incompleteTasks / totalSafe) * 100;

  return { completedPercent, incompletePercent, completedTasks, incompleteTasks, totalTasks };
};



  const { completedPercent, incompletePercent, completedTasks, incompleteTasks, totalTasks } = calculateTaskCompletion();

  















  return (
    <>
  <header className="flex flex-col sm:flex-row items-center justify-between border-b border-indigo-200/60 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl shadow-[0_12px_30px_rgba(99,102,241,0.18)] p-10 space-y-6 sm:space-y-0 rounded-2xl">
  {/* Navigation Buttons */}
  <div className="flex items-center space-x-6">
    <button
      onClick={() => handleDateChange('prev')}
      className="flex items-center px-3 py-2 text-white border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 rounded-xl shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:to-indigo-600/95 text-lg"
    >
      <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" />
      <span className="ml-2 font-semibold">Previous</span>
    </button>
    <button
      onClick={() => handleDateChange('next')}
      className="flex items-center px-3 py-2 text-white border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 rounded-xl shadow-lg shadow-indigo-950/35 mr-2 hover:from-indigo-800/95 hover:to-indigo-600/95 text-lg"
    >
      <span className="mr-2 font-semibold">Next</span>
      <ChevronRightIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  </div>

  {/* Pie Chart & Legend */}
  {pieChartData.length > 0 && (
    <div className="flex items-center space-x-8">
      {/* Legend */}
      <div className="text-lg font-semibold">
        {pieChartData.map((entry, index) => (
          <div key={`legend-${index}`} className="flex items-center space-x-3 mb-2">
            <span className="inline-block w-5 h-5 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }}></span>
            <span className="text-sm">{entry.name}</span>
          </div>
        ))}
      </div>

      {/* Pie Chart */}
      <div className="w-40 h-40">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieChartData}
              cx="50%"
              cy="50%"
              outerRadius={50} // Increased to avoid cutting labels
              fill="#8884d8"
              dataKey="value"
              label
            >
              {pieChartData.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  )}
</header>



{/* Sticky Header */}
<div className="h-full flex flex-col bg-gradient-to-b from-indigo-100 via-sky-50 to-emerald-50">
  <header className="sticky top-0 z-10 bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border-b border-indigo-200/60 shadow-[0_12px_30px_rgba(99,102,241,0.2)] p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
    <h1 className="text-xl font-bold text-indigo-600">
      {format(currentDate, "EEEE, MMMM d, yyyy")}
    </h1>
    
  
    <select
    onChange={(e) => setNewRole(e.target.value)}
      className="hidden sm:block rounded-xl border border-indigo-200/70 bg-white/80 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
    >
      
      <option value="all">All Roles</option>
      {roles.map((role, index) => (
        <option key={index} value={role}>
          {role}
        </option>
      ))}
    </select>

      

   
        <button
          onClick={handleZoomOut}
          className="rounded-xl border border-indigo-200/70 bg-white/75 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
        >
          <MagnifyingGlassMinusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
        <button
          onClick={handleZoomIn}
          className="rounded-xl border border-indigo-200/70 bg-white/75 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
        >
          <MagnifyingGlassPlusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
    <div className="flex items-center mt-2 sm:mt-0">
      <span className="text-sm sm:text-base text-indigo-900">
        {format(currentTime, "HH:mm:ss")}
      </span>
    </div>
    
      {/* Zoom Control Buttons */}
      

  </header>
  <div className="w-full bg-gradient-to-r from-indigo-100/80 via-white/85 to-purple-100/80 backdrop-blur-xl border-b border-indigo-200/60 p-4">
<div className="flex items-center space-x-4">
  {bottleneck ? (
    <button
      onClick={() => setBottleneck(null)}
      type="button"
      className="inline-flex items-center gap-x-2 rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 px-3.5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-rose-900/35 hover:from-rose-500/95 hover:to-red-400/95"
    >
      <ArrowLeftStartOnRectangleIcon aria-hidden="true" className="-ml-0.5 size-5" />
      Back
    </button>
  ) : (
      
<button onClick={() => setBottleneck(tasks)}
        type="button"
        className="inline-flex items-center gap-x-2 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3.5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-indigo-950/40 hover:from-indigo-800/95 hover:to-indigo-600/95"
      >
        <ChevronDoubleDownIcon aria-hidden="true" className="-ml-0.5 size-5" />
       Bottlenecks
      </button>
  )}

<div className="w-full bg-white/70 border border-indigo-200/70 rounded-full h-6 mb-4 overflow-hidden relative">
      <div className="flex h-full">
        {/* Completed segment */}
        <div 
          className="bg-gradient-to-r from-emerald-500 to-emerald-400 transition-all duration-300 ease-out" 
          style={{ width: `${completedPercent}%` }}
        />
        {/* Incomplete segment */}
        <div 
          className="bg-gradient-to-r from-rose-500 to-red-400 transition-all duration-300 ease-out" 
          style={{ width: `${incompletePercent}%` }}
        />
      </div>
      
      {/* Combined text overlay */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-xs font-medium">
        {totalTasks === 0 ? (
          <span>No tasks</span>
        ) : (
          <span>
            {completedTasks} Completed • {incompleteTasks} Incomplete
            <span className="text-gray-300 mx-1">|</span>
            {totalTasks} Total
          </span>
        )}
      </div>
    </div>
      
    </div>
</div>
</div>



{tasks.length === 0 && (
      <div className="p-4 rounded-2xl border border-red-200/60 bg-gradient-to-r from-rose-600/90 to-red-500/90 text-white shadow-lg shadow-rose-900/30 flex justify-between">
        <ExclamationCircleIcon className="h-12 w-12" aria-hidden="true" />
        <p className="text-lg text-white-600 mt-4">
          No tasks scheduled for today.
        </p>
        <button onClick={() => Navigate('/taskcalendar')}
        data-feature="open-task-manager"
        type="button"
        className="inline-flex items-center mr-5 gap-x-1.5 rounded-xl border border-white/20 bg-gradient-to-br from-indigo-900/90 via-sky-600/90 to-emerald-500/90 px-2.5 py-1.5 text-sm font-semibold text-white shadow-lg shadow-indigo-950/35 hover:from-indigo-800/95 hover:via-sky-500/95 hover:to-emerald-400/95"
      >
        <ClipboardDocumentCheckIcon aria-hidden="true" className="-ml-0.5 size-5" />
        Task Manager 
      </button>
        
      </div>
      )}



      
        {/* Task List */}
        <div className="flex-auto overflow-auto bg-transparent p-4 flex flex-col lg:flex-row" data-component="task-teamview">
  {/* Left Side - Task List */}
  {!bottleneck ? (
      <div className={`overflow-auto bg-transparent p-4 transition-all duration-300 ${selectedTaskId ? "w-2/3" : "w-full"}`}>

    {/* Wrap the content to apply the zoom without affecting layout */}
    <div
      className="transition-all duration-300"
      style={{ transform: `scale(${zoom})`, transformOrigin: "top left" }}
    >
    <ul className="space-y-4">
  {Object.entries(groupedTasks).map(([startTime, tasksAtTime]) => (
    <li key={startTime} className="flex space-x-4">
      {tasksAtTime.map((task) => {
        const taskStartTime = parse(task.StartTime, "HH:mm:ss", new Date());
        const taskEndTime = getTaskEndTime(task, taskStartTime);
        let cardColor = "bg-gradient-to-br from-indigo-900/85 to-indigo-700/80";
        const isBreak = task.Task.toLowerCase().includes("Break");
        const completed = task.Completed === 1;
        const isIssue = task.Issue !== null;
        const helpReceived = task.HelpSuggestions !== null;

        


        // Set status icon: if not completed, show an X icon; if completed, show a check icon.
        let statusIcon = completed ? (
          <CheckCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
        ) : (
          <XCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
        );

let issueIcon = isIssue ? (
  <div className="flex items-center space-x-2">
          <ExclamationCircleIcon className="h-6 w-6 text-white animate-pulse" aria-hidden="true" />
          {helpReceived ? (
            <span className="text-xs bg-white p-2 text-emerald-500 rounded-full px-2 py-1">
              Help Received!
            </span>
          ) : (
          <span className="text-xs bg-white p-2 text-red-500 rounded-full px-2 py-1">
            Need Help!
          </span>
          )}
        </div>
        ) : null;


        let button = null;

        // If the task has passed its end time, mark it as overdue.
        if (isBefore(taskEndTime, currentTime)) {
          cardColor = "bg-gradient-to-br from-rose-600/85 to-red-500/80";
          // If the task is completed, override with the check icon.
          if (completed) {
            statusIcon = (
              <CheckCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
            );
          }
        } else if (
          isEqual(taskStartTime, currentTime) ||
          (isBefore(taskStartTime, currentTime) && isAfter(taskEndTime, currentTime))
        ) {
          cardColor = "bg-gradient-to-br from-emerald-600/85 to-emerald-500/80";
          statusIcon = (
            <UserCircleIcon className="h-6 w-6 text-white" aria-hidden="true" />
          );
          
         
        }

        if (isBreak) {
          cardColor = "bg-gradient-to-br from-amber-500/85 to-yellow-500/80";
        }

        return (
          <div
            key={task.TaskID}
            className={classNames(
              cardColor,
              "flex border border-white/25 backdrop-blur-xl flex-col w-full rounded-2xl shadow-lg shadow-indigo-950/20 p-4 text-white"
            )}
          >
            <div className="p-4">
            <div className="flex items-center justify-between">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/85 text-indigo-900 font-semibold">
                    {task.Step}
                    </div>
                    <button onClick={() => handleTaskSelect(task.id)} data-feature="toggle-task-details">
                      <ChevronDoubleRightIcon className="w-16 h-16 text-white" />
                    </button>
                  </div>
              <p className="text-sm font-semibold">
                {task.Name} - {task.Role}
              </p>
              <p className="text-xs mt-2 mb-2">{task.ProcessName}</p>

              <div className="flex items-center space-x-2">
                {statusIcon} {issueIcon}
                {task.Priority === "High" && (
                  <span className="text-xs bg-red-500 text-white rounded-full px-2 py-1">
                    High!
                  </span>
                )}
                {task.Priority === "Medium" && (
                  <span className="text-xs bg-yellow-500 text-white rounded-full px-2 py-1">
                    Medium
                  </span>
                )}
                {task.Priority === "Low" && (
                  <span className="text-xs bg-green-500 text-white rounded-full px-2 py-1">
                    Low
                  </span>
                )}
                <button
                  onClick={() => handlePriorityChange(task.TaskID, "decrease")}
                  data-feature="decrease-task-priority_post"
                  className="rounded-xl border border-white/20 bg-white/20 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-white/30"
                >
                  <MinusCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </button>
                <button
                  onClick={() => handlePriorityChange(task.TaskID, "increase")}
                  data-feature="increase-task-priority_post"
                  className="rounded-xl border border-white/20 bg-white/10 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-white/30"
                >
                  <PlusCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                </button>
              </div>
              <p className="font-semibold mt-2">{task.Task}</p>
              {task.Description && (
                <p className="text-sm mt-2">{task.Description}</p>
              )}
              <p className="text-sm mt-2">
                <time>{format(taskStartTime, "HH:mm")}</time> -{" "}
                <time>{format(taskEndTime, "HH:mm")}</time>
              </p>
              {/* Conditionally show Issue text only if it exists */}
              
              <div className="flex items-center space-x-2 mt-2">
                <button
                  onClick={() =>
                    setChangeTask(task.TaskID) ||
                    setOpenDropdown(
                      openDropdown === task.TaskID ? null : task.TaskID
                    )
                  }
                  data-feature="toggle-task-reassign"
                  className="rounded-xl border border-white/20 bg-white/80 px-3 py-2 text-sm font-semibold text-emerald-700 shadow-sm hover:bg-white"
                >
                  <ArrowsRightLeftIcon className="h-3 w-3" aria-hidden="true" />
                </button>
                {openDropdown === task.TaskID && (
                  <div className="flex items-center space-x-2 mt-2">
                    <select
                      onChange={(e) =>
                        handleNewTask(e.target.value, task.TaskID)
                      }
                      data-component="task-reassign-select"
                      data-task-id={task.TaskID}
                      className="rounded-xl bg-white/85 border border-indigo-200/70 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
                    >
                      <option value="">Change Task</option>
                      {change.map((taskOption, index) => (
                        <option key={index} value={taskOption}>
                          {taskOption}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={() => setOpenDropdown(null)}
                      data-feature="close-task-reassign"
                      className="rounded-xl bg-white/85 border border-indigo-200/70 px-3 py-2 text-sm font-semibold text-indigo-900 shadow-sm hover:bg-white"
                    >
                      <XCircleIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                )}
              </div>
              {button}
            </div>
            
          </div>
        );
      })}
    </li>
  ))}
</ul>

    </div>
  </div>
  ) : (
    <div className="w-full overflow-auto">
<Bottlenecks tasks={tasks} onTriggerParentEffect={fetchData}
 />
    </div>
  )}



  {/* Right Side - Input Box / Instructions */}
  {selectedTaskId && (
          <div className="w-1/3 bg-gradient-to-b from-indigo-100/70 via-white/85 to-purple-100/70 backdrop-blur-xl p-4 border-l border-indigo-200/60 shadow-[0_12px_30px_rgba(99,102,241,0.2)] transition-all duration-300 overflow-auto">
            <button onClick={() => setSelectedTaskId(null)} className="mb-4 rounded-xl border border-white/20 bg-gradient-to-br from-rose-600/90 to-red-500/90 px-3 py-1 text-white hover:from-rose-500/95 hover:to-red-400/95" data-feature="close-task-details">
              Close
            </button>
            <SubstepViewer taskData = {selectedTaskId} />
          </div>
        )}
      </div>


    </>
  );
}

